import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { InvitationService } from 'src/app/services/invitation.service';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  selector: 'app-activation-control',
  templateUrl: './activation-control.component.html',
  styleUrls: ['./activation-control.component.scss'],
})
export class ActivationControlComponent {
  key!: any;
  manager!: any;
  payload: any;

  activationForm: FormGroup;

  hide: boolean = true;
  hideConfirm: boolean = true;

  numerosValidate: boolean = false;
  titlecaseValidate: boolean = false;
  lowerValidate: boolean = false;

  validateUser: boolean = false;
  errorValidateUser: string = '';
  titleConfirm!: string;
  loaded: boolean = false;
  loading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private invitationService: InvitationService,
    private activatedRouter: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthenticationService,
  ) { }

  ngOnInit(): void {
    this.activatedRouter.queryParams.subscribe({
      next: (params) => {
        this.key = params['key'];
        this.manager = params['man'];

        this.invitationService
          .verifyInvite(this.key, this.manager, {})
          .subscribe({
            next: (data) => {
              // Verificamos si la respuesta es exitosa
              if (data.success || data.code == 200) {
                this.validateUser = true;
                this.titleConfirm = data.message;

                if (
                  data.data &&
                  data.data.token &&
                  typeof data.data.token === 'string'
                ) {
                  localStorage.setItem('jwt_token', data.data.token);

                  this.auth.getUsersMe().subscribe();

                  this.openInfoDialog(
                    'Invitación aceptada correctamente. Entrando al panel...',
                    false,
                    true,
                    '/panel-control',
                  );

                  return;
                }
              }
              this.loaded = true;
            },
            error: (res) => {
              this.loaded = true;
              if (!res.error.success) {
                this.errorValidateUser =
                  res.error?.error || 'Error al validar la invitación';
              }
            },
          });
      },
    });

    this.activationForm = this.formBuilder.group(
      {
        textPassword: [
          '',
          Validators.compose([
            Validators.required,
            this.patternValidator(/\d/, { hasNumber: true }),
            this.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
            this.patternValidator(/[a-z]/, { hasSmallCase: true }),
            Validators.minLength(8),
            Validators.maxLength(30),
          ]),
        ],
        confirmPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(30),
          ],
        ],
        condaccept: [false, [Validators.required, Validators.requiredTrue]],
        newsletter: [false],
      },
      {
        validators: this.password.bind(this),
      },
    );
  }

  // Validacion contraseña
  password(formGroup: FormGroup) {
    const { value: password } = formGroup.controls['textPassword'];
    const { value: confirmPassword } = formGroup.controls['confirmPassword'];
    if (password === confirmPassword) {
      return null;
    } else {
      return { passwordNotMatch: true };
    }
  }

  patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const valid = regex.test(control.value);
      if (valid) {
        return null;
      } else {
        return error;
      }
    };
  }

  get pass() {
    return this.activationForm.get('textPassword');
  }
  get repPass() {
    return this.activationForm.get('confirmPassword');
  }

  completeInvite() {
    if (this.activationForm.invalid) {
      this.openInfoDialog(
        'Por favor, rellene todos los campos correctamente',
        true,
      );
      return;
    }
    this.loading = true;
    const password = this.activationForm.controls['textPassword'].value;
    const confirmPassword =
      this.activationForm.controls['confirmPassword'].value;
    const condaccept = this.activationForm.controls['condaccept'].value;

    const registerJson = {
      condaccept: condaccept,
      password: password,
      password_confirmation: confirmPassword,
    };
    this.invitationService
      .verifyInvite(this.key, this.manager, registerJson)
      .subscribe({
        next: (res) => {
          // Verificar si la invitación fue aceptada correctamente
          if (res.success) {
            // Si el token es false, significa que el usuario ya existe y debe iniciar sesión
            if (res.data.token === false) {
              this.openInfoDialog(
                'Invitación aceptada correctamente. Por favor, inicia sesión con tu usuario.',
                false,
                true,
                '/',
              );
            }
            // Si hay un token válido, guardar en localStorage y redirigir al panel
            else if (res.data.token) {
              localStorage.setItem('jwt_token', res.data.token);
              this.openInfoDialog(
                'Invitación aceptada correctamente. Entrando al panel...',
                false,
                true,
                '/panel-control/events',
              );
            }
            // Si no hay token y no es false, mostrar error
            else {
              this.openInfoDialog(
                '¡Vaya! No se recibió el token de autenticación.',
                true,
              );
            }
          } else {
            // Invitación no válida - mostrar mensaje del API y redirigir a homepage
            const errorMessage =
              res.message || '¡Vaya! Algo ha fallado al aceptar la invitación.';
            this.openInfoDialog(errorMessage, true, true, '/');
          }
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          // Error en la petición - redirigir a homepage
          const errorMessage =
            err?.error?.message ||
            '¡Vaya! Algo ha fallado al crear la cuenta, por favor, vuelve a intentarlo más tarde.';
          this.openInfoDialog(errorMessage, true, true, '/');
        },
      });
  }

  openInfoDialog(
    msg: any,
    icon: boolean,
    wait = false,
    route = '/panel-control',
  ) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: icon,
        text: msg,
        btnCancel: false,
      },
    });
    if (wait) {
      dialogRef.afterClosed().subscribe({
        next: () => {
          this.router.navigate([route]);
        },
      });
    }
  }
}
